<script setup>
import { computed, inject, ref } from 'vue';
import { visibleStats } from '../statSources.js';
import { countUpText } from '../countUp.js';
import { useCountUp } from '../useCountUp.js';
import { styleVars } from '../Trailhead/shared.js';

// The stats bar as the Hub draws it: the hub's weather card — one white
// card split into cells, an eyebrow over a 23px number in each. Same
// slots, resolver and Count up option as ThStats and ByStats, so the
// numbers agree across templates.
const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

// A zero or missing number is left out for a visitor, and a bar with
// nothing from the data is not drawn (visibleStats says why).
const editing = inject('tiqEditorCanvas', false);
const stats = computed(() => visibleStats(props.config, props.site_data?.stats || {}, editing));

const root = ref(null);
const progress = useCountUp(root, () => props.config.count_up);
const shown = (value) => countUpText(value, progress.value);
</script>

<template>
    <section v-if="stats.length" ref="root" :id="config.anchor_id || null" class="th-block th-sec hub-stats" :style="styleVars(config)">
        <div class="th-wrap">
            <div class="hub-stats__card">
                <div v-for="(stat, i) in stats" :key="i" class="hub-stats__cell">
                    <div class="hub-stats__label">{{ stat.label }}</div>
                    <div class="hub-stats__value">{{ shown(stat.value) }}</div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped>
.hub-stats__card {
    background: var(--block-bg, #fff);
    border: 1px solid rgba(16, 26, 21, .07);
    border-radius: 18px;
    overflow: hidden;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
}
.hub-stats__cell { padding: 16px 20px; border-right: 1px solid rgba(16, 26, 21, .06); min-width: 0; }
.hub-stats__label {
    font-size: 10.5px;
    font-weight: 800;
    letter-spacing: .09em;
    text-transform: uppercase;
    color: var(--text-sub, #5d6b63);
}
.hub-stats__value {
    margin-top: 8px;
    font-size: 23px;
    font-weight: 800;
    letter-spacing: -0.035em;
    line-height: 1;
    font-variant-numeric: tabular-nums;
    color: var(--text-heading, #101a15);
    overflow-wrap: anywhere;
}
</style>
